class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      event.preventDefault();
      this.expandShowMore(event);
      const nextElementToFocus = event.target
        .closest('.parent-display')
        .querySelector('.show-more-item');
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hide')) {
        nextElementToFocus.querySelector('input').focus();
      }
    });
  }

  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');

    this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hide'));

    parentDisplay
      .querySelectorAll('.show-more-item')
      .forEach((item) => item.classList.toggle('hide'));
  }
}

customElements.define('show-more-button', ShowMoreButton);
